import React, { useState, useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'
import './businessview-style.scss'
import IconButton from '@mui/material/IconButton'
import Details from '../../assets/images/info.png'
import Map from '../../assets/images/map.png'
import Add from '../../assets/images/add.png'
import Box from '@mui/material/Box'
import { makeStyles } from '@mui/styles'
import Grid from '@mui/material/Grid'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import ClearIcon from '@mui/icons-material/Clear'
import TextField from '@mui/material/TextField'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import { useNavigate, useLocation } from 'react-router-dom'
import usePlantBusinessViewStyles from './styles.js'
import PlantDetailsContent from '../PlantTechicalView/components/PlantDetailsDialog/PlantDetailsContent'
import {
  Deletenewplant,
  GetMonthlyInvoiceNew,
  AddlogdtaNew,
  GetlogPlantNew,
  UpdateLogDta,
  expressURL,
  DeletenewplantNew,
} from '../../services/api'
import dayjs from 'dayjs'
import DeemedReport from './components/DeemedReport/DeemedReport'
import InvoiceBill from './components/InvoiceBill/InvoiceBill'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import InvestorGuaranteedgraph from './components/InvestorGuaranteedgraph/InvestorGuaranteedgraph'
import { AddIcCallRounded } from '@material-ui/icons'
import EditDeemedLogDialog from './components/DeemedReport/EditDeemedLogDialog.jsx'
import CustomAlert from '../../components/CustomAlert/CustomAlert.jsx'
import BugReportIcon from '@mui/icons-material/BugReport'
import { fetchIssues } from '../IssueManagement/services/issueService'
import { getZohoInvoiceDetails } from './components/InvoiceBill/utils/ZohoApis.js'

import usePermission from '../../hooks/usePermission'

const PlantBusinessView = () => {
  const classes = usePlantBusinessViewStyles()
  const navigate = useNavigate()
  const { state } = useLocation()

  const { is, can } = usePermission()

  const [plantContent, setPlantContent] = React.useState([])
  const [technicalFromDate, setTechnicalFromDate] = React.useState(
    dayjs(new Date()).subtract(1, 'month')
  )
  const [technicalToDate, setTechnicalToDate] = React.useState(
    dayjs(new Date())
  )
  const [billFromDate, setBillFromDate] = React.useState(
    dayjs(new Date()).subtract(1, 'month')
  )
  const [billToDate, setBillToDate] = React.useState(dayjs(new Date()))
  const [DeemedDate, setDeemedDate] = React.useState(dayjs(new Date()))
  const [EnergyLoss, setEnergyLoss] = React.useState(0)
  const [faultType, setfaultType] = React.useState('')
  const [faultDescription, setfaultDescription] = React.useState('')
  const [DeemedFromTime, setDeemedFromTime] = React.useState(dayjs(new Date()))
  const [DeemedToTime, setDeemedToTime] = React.useState(dayjs(new Date()))
  const [DeemedLogList, setDeemedLogList] = React.useState([])
  const [accountability, setAccountability] = React.useState('DE')
  const [timePeriods, setTimePeriods] = React.useState([
    { from: null, to: null },
  ])
  const [multiplyingFactor, setMultiplyingFactor] = React.useState('')

  const [open, setOpen] = React.useState(false)
  const [open2, setOpen2] = React.useState(false)
  const [dleted, setdelete] = React.useState(false)
  const [reportOpen, setReportOpen] = React.useState(false)
  const [deemedreportOpen, setDeemedReportOpen] = React.useState(false)
  const [invoiceOpen, setInvoiceOpen] = React.useState(false)
  const [monthlyReportList, setMonthlyReportList] = React.useState([])
  const [invoiceReportList, setInvoiceReportList] = React.useState([])
  const [Totalcharge, setTotalcharge] = useState(0)
  const [invoiceDate, setInvoiceDate] = React.useState(dayjs(new Date()))
  const [Loading, setLoading] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')
  const [isAutomated, setIsAutomated] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [issueCount, setIssueCount] = useState(0)
  const [plantIssues, setPlantIssues] = useState([])

  //new
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const [selectedLog, setSelectedLog] = useState(null)
  const [isDeemedReportLoading, setIsDeemedReportLoading] = React.useState(false)

  //alert
  const [alertOpen, setAlertOpen] = useState(false)
  const [alertMessage, setAlertMessage] = useState('')
  const [alertSeverity, setAlertSeverity] = useState('success')

  const showAlert = (message, severity = 'success') => {
    setAlertMessage(message)
    setAlertSeverity(severity)
    setAlertOpen(true)
  }

  const handleAlertClose = () => {
    setAlertOpen(false)
  }

  const [errors, setErrors] = useState({
    EnergyLoss: '',
    faultType: '',
    DeemedDate: '',
    DeemedFromTime: '',
    DeemedToTime: '',
    faultDescription: '',
    accountability: '',
    multiplyingFactor: '',
  })

  // Initialize state
  const [zohoState, setZohoState] = useState({
    organizationName:
      state?.data?.entity?.billerDetails?.entityName || '',
    organizationGstNo: '',
    customerState: state?.data?.entity?.state || '',
    customerCountry: state?.data?.entity?.country || '',
    organizationState: state?.data?.entity?.billerDetails?.state || '',
    organizationCountry:
      state?.data?.entity?.billerDetails?.country || '',
    isLocationMatched: false,
    plantName: state?.data?.plantName || '',
    orgAddress: state?.data?.entity?.billerDetails?.entityAddress || '',
    latestInvoiceBillingAddress: '', // New field for latest invoice billing address
    customerGstNo: '',
  })
  console.log(
    'state.data',
    state?.data?.entity?.billerDetails?.entityName
  )

  console.log("zohoState", zohoState);
  console.log("state.data", state?.data);



  const getZohoInvoiceData = async () => {
    console.log('Fetching Zoho invoice data organization...', state.data.organization?.organizationCode)

    try {
      const organizationId = state.data.organization?.organizationCode
      const zohoResponse = await getZohoInvoiceDetails(organizationId)

      if (zohoResponse && zohoResponse.data) {
        // console.log('zohoData:', zohoResponse.data)

        const zohoData = zohoResponse.data

        // Extract organization data
        const rawName = zohoData.organization?.name || ''
        const organizationName = rawName
          .replace(/\s*\(Formerly known as.*?\)\s*/i, '')
          .trim()
        const organizationState = zohoData.organization?.state || ''
        const organizationCountry = zohoData.organization?.country || ''
        const organizationAddress =
          zohoData.organization?.raw_additional_sources
        const addressData = organizationAddress?.[0]?.data?.address
        let fullAddress = zohoData.organization?.address.formatted_address || ''
        let organizationGstNo = zohoData.organization?.gst_number || ''

        // Find matching customer by plant name
        const matchingCustomer = zohoData.customers?.data?.find(
          (customer) =>
            customer.company_name === state.data.plantName ||
            customer.contact_name === state.data.plantName
        )

        let customerState = ''
        let customerCountry = ''
        let customerGstNo = ''

        if (matchingCustomer) {
          customerState = matchingCustomer.state || ''
          customerGstNo = matchingCustomer.gst_number || ''
        }

        // Find invoices that match the plant name
        const matchingInvoices =
          zohoData.invoices?.data?.filter(
            (invoice) =>
              invoice.customer_name === state.data.plantName ||
              invoice.company_name === state.data.plantName
          ) || []

        // console.log('Matching invoices found:', matchingInvoices.length)

        // Find the invoice with the latest created_time
        let latestInvoice = null
        let latestInvoiceBillingAddress = ''

        if (matchingInvoices.length > 0) {
          latestInvoice = matchingInvoices.reduce((latest, current) => {
            const latestDate = new Date(latest.created_time)
            const currentDate = new Date(current.created_time)
            return currentDate > latestDate ? current : latest
          })

          // Extract billing address from the latest invoice
          if (latestInvoice && latestInvoice.billing_address) {
            const billingAddr = latestInvoice.billing_address
            latestInvoiceBillingAddress =
              [
                billingAddr.address,
                billingAddr.street2,
                billingAddr.city,
                billingAddr.state,
                billingAddr.zipcode,
                billingAddr.country,
              ]
                .filter(Boolean)
                .join(', ') ||
              billingAddr.address ||
              ''
          }

          // console.log('Latest invoice found:', {
          //   invoice_number: latestInvoice.invoice_number,
          //   created_time: latestInvoice.created_time,
          //   billing_address: latestInvoiceBillingAddress,
          // })
        } else {
          console.log(
            'No matching invoices found for plant name:',
            state.data.plantName
          )
        }

        // console.log('isLocationMatched', organizationState, customerState)

        // Check if organization and customer locations match
        const isLocationMatched = organizationState === customerState

        // Update state with all extracted data including latest invoice billing address
        setZohoState((prevState) => ({
          ...prevState,
          organizationName,
          organizationGstNo,
          customerState,
          customerCountry,
          organizationState,
          organizationCountry,
          isLocationMatched,
          orgAddress: fullAddress || '',
          plantName: state.data.plantName,
          latestInvoiceBillingAddress,
          customerGstNo, // Store the billing address from latest invoice
        }))

        // console.log('Updated Zoho State:', {
        //   organizationName,
        //   organizationGstNo,
        //   customerState,
        //   customerCountry,
        //   organizationState,
        //   organizationCountry,
        //   isLocationMatched,
        //   latestInvoiceBillingAddress,
        //   customerGstNo
        // })
      }
    } catch (error) {
      console.log('Error fetching Zoho invoice details:', error.message)
    }
  }

  const calculateTotalDuration = (periods) => {
    return periods.reduce((total, period) => {
      if (period.from && period.to) {
        const startTime = dayjs(period.from)
        const endTime = dayjs(period.to)
        const durationInMinutes = endTime.diff(startTime, 'minute')
        return total + durationInMinutes
      }
      return total
    }, 0)
  }

  useEffect(() => {
    ; (async () => {
      await getZohoInvoiceData()
    })()
  }, [])
  useEffect(() => {
    setPlantContent(state?.data)
  }, [state])

  const updateAutomationStatus = async (plantId, status) => {
    const authToken = localStorage.getItem('accessToken')
    const response = await fetch(
      // ' https://prod.backend.v2.express.de.energy/api/invoices/email/automation',
      `${expressURL}/invoices/email/automation`,

      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(authToken && { Authorization: `Bearer ${authToken}` }),
        },
        body: JSON.stringify({
          plantId: plantId,
          automation: status,
        }),
      }
    )

    if (!response.ok) {
      throw new Error('Failed to update automation status')
    }

    return await response.json()
  }
  const plantId = state?.data?.id

  const handleToggleChange = async (e) => {
    e.stopPropagation() // Prevent triggering the button click
    setIsLoading(true)

    try {
      const newStatus = !isAutomated // Toggle the current status
      if (plantId) {
        const status = await updateAutomationStatus(plantId, newStatus)

        setIsAutomated(newStatus)
      }
    } catch (error) {
      console.error('Error updating automation status:', error)
      // On error, revert to the previous state
      setIsAutomated(isAutomated)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const plantId = state?.data?.id
    GetlogPlantNew(plantId, state?.token).then((resp) => {
      if (resp?.data) {
        console.log(resp?.data)
        setDeemedLogList(resp?.data)
        setIsDeemedReportLoading(false)
      } else {
        setIsDeemedReportLoading(false)
      }
    })

    const fetchAutomationStatus = async () => {
      if (!plantId) return

      try {
        const authToken = localStorage.getItem('accessToken')
        const response = await fetch(
          `${expressURL}/invoices/email/automation/${plantId}`,
          {
            headers: {
              ...(authToken && { Authorization: `Bearer ${authToken}` }),
            },
          }
        )

        if (response.ok) {
          const data = await response.json()

          // Set based on data from server, default to false if not available
          setIsAutomated(data?.data?.automation || false)
        } else {
          // Default to false if server response is not ok
          setIsAutomated(false)
        }
      } catch (error) {
        console.error('Error fetching automation status:', error)
        setIsAutomated(false)
      }
    }

    fetchAutomationStatus()
  }, [open, state?.data?.id, state?.data?.plantName, state?.token])

  const validateForm = () => {
    let isValid = true
    const newErrors = { ...errors }

    // Validate EnergyLoss
    if (!EnergyLoss) {
      newErrors.EnergyLoss = 'Energy Loss is required'
      isValid = false
    } else {
      newErrors.EnergyLoss = ''
    }

    // Validate faultType
    if (!faultType) {
      newErrors.faultType = 'Fault Type is required'
      isValid = false
    } else {
      newErrors.faultType = ''
    }

    // Validate DeemedDate
    if (!DeemedDate) {
      newErrors.DeemedDate = 'Choose Date is required'
      isValid = false
    } else {
      newErrors.DeemedDate = ''
    }

    // Validate DeemedFromTime
    if (!DeemedFromTime) {
      newErrors.DeemedFromTime = 'Start Time is required'
      isValid = false
    } else {
      newErrors.DeemedFromTime = ''
    }

    // Validate DeemedToTime
    if (!DeemedToTime) {
      newErrors.DeemedToTime = 'End Time is required'
      isValid = false
    } else {
      newErrors.DeemedToTime = ''
    }

    // Validate faultDescription
    if (!faultDescription) {
      newErrors.faultDescription = 'Fault Description is required'
      isValid = false
    } else {
      newErrors.faultDescription = ''
    }

    setErrors(newErrors)
    return isValid
  }

  // timeperiods helper functions
  const addTimePeriod = () => {
    setTimePeriods([...timePeriods, { from: null, to: null }])
  }

  const removeTimePeriod = (index) => {
    if (timePeriods.length > 1) {
      const newPeriods = [...timePeriods]
      newPeriods.splice(index, 1)
      setTimePeriods(newPeriods)
    }
  }

  // Add this useEffect to automatically calculate Energy Loss
  useEffect(() => {
    const totalDurationMinutes = calculateTotalDuration(timePeriods)
    const calculatedEnergyLoss = totalDurationMinutes * (multiplyingFactor || 0)
    setEnergyLoss(calculatedEnergyLoss)
  }, [timePeriods, multiplyingFactor])

  // Update the updateTimePeriod function to trigger recalculation
  const updateTimePeriod = (index, field, value) => {
    const newPeriods = [...timePeriods]
    newPeriods[index][field] = value
    setTimePeriods(newPeriods)
  }

  const handleEditLog = (logData) => {
    setSelectedLog(logData)
    setEditDialogOpen(true)
  }

  const handleSaveEditLog = async (updatedData) => {
    try {
      // Process the data similar to how it's done in handleSaveDeemedLog
      const processedData = {
        ...updatedData,
        energyLoss: Number(updatedData.energyLoss) || 0,
        multiplyingFactor: Number(updatedData.multiplyingFactor) || undefined,
      }

      const response = await UpdateLogDta(
        updatedData.logId,
        processedData,
        state?.token
      )

      console.log('response', response)

      // Check for successful status codes (200-299) instead of response.data
      if (response?.status >= 200 && response?.status < 300) {
        showAlert('Log updated successfully.', 'success') // Replace alert()
        await refreshLogs()
        setEditDialogOpen(false)
        setSelectedLog(null)
      } else {
        showAlert('Failed to update log', 'error') // Replace alert()
        console.error('Update failed:', response)
      }
    } catch (error) {
      showAlert('Error updating log', 'error') // Replace alert()
      console.error('Update error:', error)
    }
  }

  const handleSaveDeemedLog = () => {
    if (validateForm()) {
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ]
      const today = new Date(DeemedDate)
      const CurrentMonth = today.getMonth()

      const durationString = timePeriods
        .map((period) => {
          if (!period.from || !period.to) return null
          return `${period.from.format('HH:mm')} : ${period.to.format('HH:mm')}`
        })
        .filter(Boolean)
        .join(' | ')

      const data = {
        plantId: state?.data?.id,
        logDate: DeemedDate,
        //duration: `${DeemedFromTime.format('HH:mm')} : ${DeemedToTime.format('HH:mm')}`,
        duration: durationString,
        energyLoss: EnergyLoss,
        description: faultDescription,
        faultType: faultType,
        logMonth: months[CurrentMonth],
        accountability: accountability,
        multiplyingFactor: multiplyingFactor,
      }
      AddlogdtaNew(data, state?.token).then((resp) => {
        if (resp?.data) {
          setOpen(false)
          setEnergyLoss(0)
          setfaultDescription('')
          setfaultType('')
          setAccountability('DE')
          resetTimePeriods()
        } else {
        }
      })
    }
  }

  const resetTimePeriods = () => {
    setTimePeriods([{ from: null, to: null }])
  }

  const handleOpen2 = () => {
    setOpen2(true)
  }

  const handleClose2 = () => {
    setOpen2(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const userType = localStorage.getItem('userType')
  //console.log("User type:", userType);
  const isAuthorised = localStorage.getItem('Authorised') === 'true'
  //console.log("IS authorised?", isAuthorised);
  const handleOpenReport = () => {
    const plantId = state?.data?.id

    const Fromdate = technicalFromDate.format('YYYY-MM-DD')

    const Todate = technicalToDate.format('YYYY-MM-DD')

    navigate('/monthlygeneration', {
      state: {
        data: state?.data,
        token: state?.token,
        fromDate: technicalFromDate,
        toDate: technicalToDate,
        state: state,
        Fromdate: Fromdate,
        Todate: Todate,
      },
    })
  }

  const handleInvoiceopen = async () => {
    const plantId = state?.data?.id
    let chosenDate = dayjs(invoiceDate)

    const firstDate = chosenDate.startOf('month')
    const lastDate = chosenDate.endOf('month')
    const Fromdate = firstDate.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
    const Todate = lastDate.format('YYYY-MM-DDTHH:mm:ss.SSSZ')

    // Format record date as YYYY-MM for V4 API
    const recordDateYYYYMM = chosenDate.format('YYYY-MM')

    try {
      // Fetch billing record for the selected month using V4 API
      const apiUrl = process.env.REACT_APP_NEW_BASE_V4_URL_MONITORING
      const authToken = localStorage.getItem('accessToken')
      const billingResponse = await fetch(
        `${apiUrl}billing?plantId=${plantId}&recordDate=${recordDateYYYYMM}`,
        {
          headers: {
            Accept: 'application/json',
            ...(authToken && { Authorization: `Bearer ${authToken}` }),
          },
        }
      )

      if (!billingResponse.ok) {
        throw new Error('Failed to fetch billing record')
      }

      const billingResult = await billingResponse.json()

      // Check if billing record exists
      if (!billingResult.success || !billingResult.data || billingResult.data.length === 0) {
        showAlert('No billing record found for this month. Please contact Asset Management.', 'warning')
        return
      }

      // Check if billing record is verified
      const billingRecord = billingResult.data[0]
      if (billingRecord.paymentStatus === 'To Be Verified') {
        showAlert(
          'Billing record is not verified yet. Please contact Asset Management.',
          'warning'
        )
        return
      }

      // Billing record found and status allows - fetch invoice data and show success notification
      GetMonthlyInvoiceNew(plantId, state?.token, Fromdate, Todate).then(
        (resp) => {
          if (resp) {
            setInvoiceReportList(resp?.data)
          }
        }
      )

      // Show success notification with plant name and month/year
      const monthYear = chosenDate.format('MMMM YYYY')
      showAlert(
        `Billing record loaded for ${state?.data?.plantName} — ${monthYear}.`,
        'success'
      )

      setInvoiceOpen(true)
    } catch (error) {
      console.error('Error fetching billing record:', error)
      showAlert('Error loading billing record. Please try again.', 'error')
    }
  }

  const handleChangeInvoiceDate = (value) => {
    const chosenDate = dayjs(value)
    setInvoiceDate(chosenDate)
  }

  const handleChooseDate = (value, type) => {
    const chosenDate = dayjs(value)
    if (type === 'from') {
      const firstDate = chosenDate
      setTechnicalFromDate(firstDate)
    } else if (type === 'to') {
      const lastDate = chosenDate.endOf('month')
      setTechnicalToDate(lastDate)
    }
  }

  const handlereportClose = () => {
    setReportOpen(false)
  }
  const handleDeemedOpenReport = async () => {
    setDeemedReportOpen(true)
    setIsDeemedReportLoading(true)
    try {
      await refreshLogs()
    } catch (error) {
      console.error('Error refreshing logs:', error)
    } finally {
      setIsDeemedReportLoading(false)
    }
  }

  const handleDeemedreportClose = () => {
    setDeemedReportOpen(false)
  }

  const handleInvoiceClose = () => {
    setInvoiceOpen(false)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpenEdit = () => {
    navigate('/addnewplant', {
      state: { plantData: plantContent, Edit: true, token: state?.token },
    })
  }

  const handleopenDelete = () => {
    setdelete(true)
  }

  const handleCloseDelete = () => {
    setdelete(false)
  }

  const handleDeleteplant = (id) => {
    DeletenewplantNew(id, state?.token).then((resp) => {
      if (resp?.data) {
        setOpen(true)
        setdelete(false)
        navigate('/solarplantlist')
      } else {
      }
    })
  }

  const handleTechnicalView = () => {
    navigate('/TechnicalView', {
      state: { data: state?.data, token: state?.token },
    })
  }
  const [age, setAge] = React.useState('')

  const handleChange = (event) => {
    setAge(event.target.value)
  }

  const handlePlantMapView = () => {
    navigate('/PlantMapView', { state: state })
  }

  // Issue Management handlers
  const handleIssueManagement = () => {
    const plantId = state?.data?.id
    const plantName = state?.data?.plantName
    navigate(
      `/issue-management?plantId=${plantId}&plantName=${encodeURIComponent(
        plantName
      )}`
    )
  }

  const loadPlantIssues = async () => {
    try {
      const issues = await fetchIssues({ plantId: state?.data?.id })
      const openIssues = issues.filter((issue) =>
        ['Open', 'In Progress'].includes(issue.status)
      )
      setPlantIssues(openIssues)
      setIssueCount(openIssues.length)
    } catch (error) {
      console.error('Error loading plant issues:', error)
    }
  }

  useEffect(() => {
    if (state?.data?.id) {
      loadPlantIssues()
      // Refresh issues every 5 minutes
      const intervalId = setInterval(loadPlantIssues, 300000)
      return () => clearInterval(intervalId)
    }
  }, [state?.data?.id])

  useEffect(() => {
    if (state?.data?.proposalType?.type === 'EMI') {
      setTotalcharge(
        (
          plantContent?.invertorGeneration *
          plantContent?.proposalType?.totalMonthlyAmount
        ).toFixed(2)
      )
    } else {
      setTotalcharge(
        (
          plantContent?.invertorGeneration * plantContent?.proposalType?.tariff
        ).toFixed(2)
      )
    }
  })

  const DeemedlogData = DeemedLogList.filter(
    (item) => item.plantId === state?.data?.id
  )

  const MenuData = [
    'Grid Failure',
    'Inverter Failure',
    'Manually inverter/breaker turned off',
    'Any Equipment Failure',
    'Any Other Fault',
  ]

  const datePickerStyle = {
    width: '130px',
  }

  const refreshLogs = async () => {
    const resp = await GetlogPlantNew(plantId, state.token)
    if (resp.status === 200) setDeemedLogList(resp.data)
  }

  return (
    <div className={classes.root} id="plantBusinessView">
      <div className="align_btw mb_10">
        <div>
          <div className="businessview_list_h">
            <div className="h_txt1">{state?.data?.plantName}</div>
            <div className="h_txt2">{state?.data?.projectCode}</div>
          </div>
        </div>
        <div>
          <div className="align_end wrap">
            <div className="businessview_h_button mr_8" onClick={handleOpen2}>
              {' '}
              <img src={Details} alt="details" className="mr_6" /> Plant Details
            </div>
            <div
              className="businessview_h_button mr_8"
              onClick={handlePlantMapView}
            >
              {' '}
              <img src={Map} alt="details" className="mr_6" /> Location
            </div>

            {/* Issue Management Buttons - Hidden for Finance */}
            {(is('Super Admin') || is('Admin') || is('Asset Management')) && (
              <div
                className="businessview_h_button mr_8"
                onClick={handleIssueManagement}
                style={{ position: 'relative' }}
              >
                <BugReportIcon className="mr_6" style={{ fontSize: '18px' }} />
                Issues
                {issueCount > 0 && (
                  <span
                    className="issue-badge"
                    style={{
                      position: 'absolute',
                      top: '-5px',
                      right: '-5px',
                      background: '#d32f2f',
                      color: 'white',
                      borderRadius: '50%',
                      width: '20px',
                      height: '20px',
                      fontSize: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    {issueCount}
                  </span>
                )}
              </div>
            )}

            <div className="business_tech_toggle" onClick={handleTechnicalView}>
              <label class="switch">
                <input type="checkbox" checked />
                <span class="slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <hr className="brdr_btm" />

      <Dialog
        className="plant_details_dialog"
        open={deemedreportOpen}
        onClose={handleDeemedreportClose}
        maxWidth="xl"
        fullWidth
      >
        <DialogActions>
          <ClearIcon onClick={handleDeemedreportClose} className="pointer" />
        </DialogActions>

        <div className="header">
          <div className="align_btw brdr">
            <div>
              <div className="h_1">Deemed Generation Log Report</div>
            </div>
          </div>
        </div>
        <DialogContent>
          {isDeemedReportLoading ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '400px',
                gap: 2,
              }}
            >
              <CircularProgress
                sx={{ color: '#5968B7' }}
                size={60}
                thickness={4}
              />
              <Typography
                variant="h6"
                sx={{
                  color: '#5968B7',
                  marginTop: '20px',
                  fontWeight: 500,
                  fontFamily: 'inherit',
                }}
              >
                Loading Deemed Generation Logs...
              </Typography>
            </Box>
          ) : (
            <DeemedReport
              DeemedlogData={DeemedlogData}
              state={state}
              refreshLogs={refreshLogs}
              onEditLog={handleEditLog}
            />
          )}
        </DialogContent>
      </Dialog>

      <EditDeemedLogDialog
        open={editDialogOpen}
        onClose={() => {
          setEditDialogOpen(false)
          setSelectedLog(null)
        }}
        logData={selectedLog || {}}
        onSave={handleSaveEditLog}
        plantData={state?.data}
        isAuthorised={isAuthorised}
      />

      <Dialog
        className="plant_details_dialog"
        open={invoiceOpen}
        onClose={handleInvoiceClose}
        maxWidth="xl"
        fullWidth
      >
        <DialogActions>
          <ClearIcon onClick={handleInvoiceClose} className="pointer" />
        </DialogActions>

        <div className="header">
          <div className="align_btw brdr">
            <div>
              <div className="h_1">Invoice</div>
            </div>
          </div>
        </div>
        <DialogContent>
          <InvoiceBill
            DeemedlogData={DeemedlogData}
            invoiceReportList={invoiceReportList}
            invoiceDate={invoiceDate}
            state={state}
            zohoState={zohoState}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        className="plant_details_dialog"
        open={reportOpen}
        onClose={handlereportClose}
        maxWidth="xl"
        fullWidth
      >
        <DialogActions>
          <ClearIcon onClick={handlereportClose} className="pointer" />
        </DialogActions>

        <div className="header">
          <div className="align_btw brdr">
            <div>
              <div className="h_1">Monthly Genaration Report</div>
            </div>
          </div>
        </div>
        <DialogContent></DialogContent>
      </Dialog>

      <Dialog
        className="plant_details_dialog"
        open={open2}
        onClose={handleClose2}
        maxWidth="xl"
        fullWidth
      >
        <DialogActions>
          <ClearIcon onClick={handleClose2} className="pointer" />
        </DialogActions>

        <div className="header">
          <div className="align_btw brdr">
            <div>
              <div className="h_1">Plant Details</div>
            </div>
            <div>
              <div className="align_end">
                <span className="h_2">{plantContent?.plantName}</span>{' '}
                {(is('Super Admin') || is('Admin')) && (
                  <>
                    <IconButton onClick={handleOpenEdit}>
                      <EditIcon className="i_clr" />
                    </IconButton>
                    <IconButton onClick={handleopenDelete}>
                      <DeleteIcon className="i_clr" />
                    </IconButton>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <DialogContent>
          <PlantDetailsContent
            plantData={plantContent}
            dleted={dleted}
            handleCloseDelete={handleCloseDelete}
            handleDeleteplant={handleDeleteplant}
          />
        </DialogContent>
      </Dialog>

      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <div className="businessview_left_bg column_align">
                <div className="txt1">Revenue Generated</div>
                <div className="txt2">
                  {plantContent?.currency === 'INR'
                    ? '₹'
                    : plantContent?.currency === 'USD'
                      ? '$'
                      : ''}{' '}
                  {Totalcharge}
                </div>
                <div />
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="businessview_left_bg column_align">
                <div className="txt1">Deemed Generation Log</div>
                <div>
                  <div className="mb_10 text_center">
                    {(is('Super Admin') || is('Admin') || is('Asset Management')) && (
                      <button className="new_entry_btn" onClick={handleOpen}>
                        New Entry
                      </button>
                    )}
                  </div>
                  <div className="text_center">
                    <button
                      className="view_report_btn"
                      onClick={handleDeemedOpenReport}
                    >
                      View Report
                    </button>
                  </div>
                </div>
              </div>

              <Dialog
                className="businessview_dialog"
                open={open}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle>
                  <div className="align_btw brdr">
                    <div className="h_1">Deemed Generation Log Entry</div>

                    <DialogActions>
                      <ClearIcon onClick={handleClose} className="pointer" />
                    </DialogActions>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <div className="capacity" style={{ textAlign: 'right' }}>
                        Capacity {state?.data?.plantSize}KW
                      </div>
                    </Grid>
                    {/* <Grid item xs={12} md={6}>
                      <TextField
                        label="Energy Loss"
                        onChange={(value) =>
                          setEnergyLoss(Number(value.target.value))
                        }
                        error={Boolean(errors.EnergyLoss)}
                        helperText={errors.EnergyLoss}
                        variant="outlined"
                        fullWidth
                        type="Number"
                      />
                    </Grid> */}

                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Energy Loss (Auto Calculated)"
                        value={EnergyLoss}
                        disabled
                        variant="outlined"
                        fullWidth
                        type="text"
                        helperText={`Total Duration: ${calculateTotalDuration(
                          timePeriods
                        )} minutes × Multiplying Factor: ${multiplyingFactor || 0
                          } = ${EnergyLoss}`}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl sx={{ width: '100%' }}>
                        <InputLabel
                          id="demo-simple-select-filled-label"
                          className="form_label"
                        >
                          Fault Type
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-filled-label"
                          id="demo-simple-select-filled"
                          value={faultType}
                          onChange={(value) => setfaultType(value.target.value)}
                          error={Boolean(errors.faultType)}
                          helperText={errors.faultType}
                          sx={{
                            borderRadius: '5px',
                            backgroundColor: '#fff',
                            boxShadow: '4px 4px 15px rgba(0, 0, 0, 0.05)',
                          }}
                        >
                          {MenuData &&
                            MenuData.map((data) => (
                              <MenuItem value={data}>{data}</MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Multiplying Factor"
                        type="number"
                        value={multiplyingFactor}
                        onChange={(e) =>
                          setMultiplyingFactor(Number(e.target.value))
                        }
                        disabled={!isAuthorised}
                        variant="outlined"
                        fullWidth
                        helperText={
                          !isAuthorised
                            ? 'Only authorized users can edit this'
                            : ''
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            label="Choose Date"
                            maxDate={dayjs()}
                            format="DD-MM-YYYY"
                            value={DeemedDate}
                            onChange={(value) => setDeemedDate(value)}
                            error={errors.DeemedDate}
                            helperText={errors.DeemedDate}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      {timePeriods.map((period, index) => (
                        <div
                          key={index}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                          }}
                        >
                          <div style={{ display: 'flex', flex: 1 }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={['TimePicker']}>
                                <TimePicker
                                  label="Start Time"
                                  value={period.from}
                                  onChange={(value) =>
                                    updateTimePeriod(index, 'from', value)
                                  }
                                  sx={{ marginRight: '10px' }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={['TimePicker']}>
                                <TimePicker
                                  label="End Time"
                                  value={period.to}
                                  onChange={(value) =>
                                    updateTimePeriod(index, 'to', value)
                                  }
                                  sx={{ marginRight: '10px' }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </div>
                          {timePeriods.length > 1 && (
                            <IconButton onClick={() => removeTimePeriod(index)}>
                              <DeleteIcon />
                            </IconButton>
                          )}
                          {index === timePeriods.length - 1 && (
                            <IconButton onClick={addTimePeriod}>
                              <AddIcon />
                            </IconButton>
                          )}
                        </div>
                      ))}
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        label="Fault Description"
                        multiline
                        rows={4}
                        onChange={(value) =>
                          setfaultDescription(value.target.value)
                        }
                        error={errors.faultDescription}
                        helperText={errors.faultDescription}
                        variant="outlined"
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl sx={{ width: '100%' }}>
                        <InputLabel
                          id="accountability-label"
                          className="form_label"
                        >
                          Accountability
                        </InputLabel>
                        <Select
                          labelId="accountability-label"
                          id="accountability-select"
                          value={accountability}
                          label="Accountability"
                          onChange={(e) => setAccountability(e.target.value)}
                        >
                          <MenuItem value="DE">DE</MenuItem>
                          <MenuItem value="Customer">Customer</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <DialogActions>
                    <button className="save_btn" onClick={handleSaveDeemedLog}>
                      Save
                    </button>
                  </DialogActions>
                </DialogContent>
              </Dialog>
            </Grid>
            <Grid item xs={12} md={12}>
              <div className="businessview_left_bg column_align">
                <div className="txt1 mb_10">Generate Bill</div>
                <div className="bg2 mb_10">
                  <div className="txt1 mb_10">Choose Date</div>
                  <div className="align_start">
                    <div className="mr_15">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <div style={datePickerStyle}>
                            <DatePicker
                              views={['month', 'year']}
                              style={{ width: '120px !important' }}
                              label="Date"
                              className={classes.datePicker}
                              maxDate={dayjs()}
                              minDate={dayjs().year(1900).startOf('year')}
                              format="MM YYYY"
                              value={invoiceDate}
                              onChange={(value) =>
                                handleChangeInvoiceDate(value)
                              }
                            />
                          </div>
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
                <div className="text_end">
                  {can('invoice.read') && (
                    <button onClick={handleInvoiceopen} className="new_entry_btn">
                      Download Report
                    </button>
                  )}
                  {/* <button
                    className={`new_entry_btn ${
                      isAutomated ? 'automated' : ''
                    }`}
                    onClick={() => {}}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Processing...' : 'Auto Generate'}
                    <div className="switch-container">
                      <div className="switch">
                        <input
                          type="checkbox"
                          id="toggleSwitch"
                          checked={isAutomated}
                          onChange={handleToggleChange}
                          disabled={isLoading}
                        />
                        <label
                          htmlFor="toggleSwitch"
                          className="slider"
                        ></label>
                      </div>
                    </div>
                  </button> */}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={12}>
              <div className="businessview_left_bg column_align">
                <div className="txt1 mb_10">Monthly Generation Report</div>
                <div className="bg2 mb_10">
                  <div className="txt1 mb_10">Choose Period</div>
                  <div className="align_start">
                    {/* <div className="txt2">From</div> */}
                    <div className="mr_15">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <div style={datePickerStyle}>
                            <DatePicker
                              views={['month', 'year']}
                              style={{ width: '120px !important' }}
                              label="From Date"
                              className={classes.datePicker}
                              format="MM YYYY"
                              maxDate={
                                dayjs(technicalFromDate)
                                  .add(5, 'month')
                                  .isAfter(dayjs(technicalToDate))
                                  ? dayjs(technicalToDate)
                                  : dayjs(technicalFromDate).add(5, 'month')
                              }
                              minDate={dayjs(technicalToDate).subtract(
                                5,
                                'month'
                              )}
                              value={technicalFromDate}
                              onChange={(value) =>
                                handleChooseDate(value, 'from')
                              }
                            />
                          </div>
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                    <div>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <div style={datePickerStyle}>
                            <DatePicker
                              views={['month', 'year']}
                              style={{ width: '120px !important' }}
                              label="From Date"
                              className={classes.datePicker}
                              format="MM YYYY"
                              maxDate={
                                dayjs(technicalFromDate)
                                  .add(5, 'month')
                                  .isAfter(dayjs())
                                  ? dayjs()
                                  : dayjs(technicalFromDate).add(5, 'month')
                              }
                              minDate={
                                dayjs(technicalToDate)
                                  .subtract(5, 'month')
                                  .isBefore(dayjs(technicalFromDate))
                                  ? dayjs(technicalFromDate)
                                  : dayjs(technicalToDate).subtract(5, 'month')
                              }
                              value={technicalToDate}
                              onChange={(value) =>
                                handleChooseDate(value, 'to')
                              }
                            />
                          </div>
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
                <div className="text_end">
                  <button className="new_entry_btn" onClick={handleOpenReport}>
                    Download Report
                  </button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={7}>
          <InvestorGuaranteedgraph
            state={state?.data}
            plantContent={plantContent}
            token={state?.token}
          />
        </Grid>
      </Grid>

      <CustomAlert
        open={alertOpen}
        handleClose={handleAlertClose}
        message={alertMessage}
        severity={alertSeverity}
      />
    </div>
  )
}

export default PlantBusinessView
